import { parse } from "date-fns";

import { TReportsFiltersFormData } from "./reports.schema";
import { TSaleReportFilters } from "./reports.types";
import { TSupplierReportsFiltersFormData } from "./supplier-reports.schema";

export function parseReportFilterDate(dateString: string): Date | null {
  if (!dateString) return null;
  try {
    const parsed = parse(dateString, "dd/MM/yyyy", new Date());
    return isNaN(parsed.getTime()) ? null : parsed;
  } catch {
    return null;
  }
}

function appendSaleDateRange(
  filters: TSaleReportFilters,
  startDate: Date | null,
  endDate: Date | null
) {
  if (!startDate && !endDate) return;
  filters.sale_date = {};
  if (startDate) {
    filters.sale_date.start_date = startDate.toISOString().split("T")[0];
  }
  if (endDate) {
    filters.sale_date.end_date = endDate.toISOString().split("T")[0];
  }
}

function appendStatusFilter(
  filters: TSaleReportFilters,
  status: string | undefined
) {
  if (!status || status === "") return;
  if (status === "approved") filters.status = "paid";
  else if (status === "pending") filters.status = "pending";
  else if (status === "failed") filters.status = "failed";
  else if (status === "refunded") filters.status = "refunded";
}

export function buildGeneralReportFilters(
  data: TReportsFiltersFormData
): TSaleReportFilters {
  const filters: TSaleReportFilters = {};
  const startDate = data.start_date
    ? parseReportFilterDate(data.start_date)
    : null;
  const endDate = data.end_date ? parseReportFilterDate(data.end_date) : null;

  appendSaleDateRange(filters, startDate, endDate);
  appendStatusFilter(filters, data.status);

  if (data.partner_name && data.partner_name !== "") {
    filters.partner = data.partner_name;
  }
  if (data.client_name && data.client_name !== "") {
    filters.customer_name = data.client_name;
  }
  if (data.client_cpf && data.client_cpf !== "") {
    filters.customer_cpf = data.client_cpf;
  }
  if (data.sale_id && data.sale_id !== "") {
    filters.sale_id = data.sale_id;
  }

  if (data.minimum_price || data.maximum_price) {
    filters.value_sale = {};
    if (data.minimum_price && data.minimum_price !== "") {
      const cleanedValue = data.minimum_price.replace(/[^\d,\.]/g, "");
      const minValue = parseFloat(cleanedValue.replace(",", "."));
      if (!isNaN(minValue) && minValue > 0) {
        filters.value_sale.min = Math.round(minValue * 100);
      }
    }
    if (data.maximum_price && data.maximum_price !== "") {
      const cleanedValue = data.maximum_price.replace(/[^\d,\.]/g, "");
      const maxValue = parseFloat(cleanedValue.replace(",", "."));
      if (!isNaN(maxValue) && maxValue > 0) {
        filters.value_sale.max = Math.round(maxValue * 100);
      }
    }
  }

  return filters;
}

export function buildSupplierReportFilters(
  data: TSupplierReportsFiltersFormData
): TSaleReportFilters {
  const filters: TSaleReportFilters = {
    insurance_company_id: data.insurance_company_id,
  };

  if (data.product_id && data.product_id !== "") {
    filters.product_id = data.product_id;
  }

  const startDate = data.start_date
    ? parseReportFilterDate(data.start_date)
    : null;
  const endDate = data.end_date ? parseReportFilterDate(data.end_date) : null;
  appendSaleDateRange(filters, startDate, endDate);
  appendStatusFilter(filters, data.status);

  return filters;
}
